import { Injectable } from '@angular/core';
import { RectilinearView } from 'marzipano';
import { IScreenCoords, ISphericalCoords } from '@newroom-connect/library/interfaces';

import { MarzipanoCoordinateSystem } from '../models/marzipano-coordinate-system.model';

/**
 * Minimal coordinate service for Marzipano scenes.
 * Only exposes methods actually used by directives.
 */
@Injectable({
  providedIn: 'root'
})
export class MarzipanoCoordinateService {
  private coordinateSystem = new MarzipanoCoordinateSystem();

  /**
   *
   * @param view - The Marzipano RectilinearView instance.
   * @param element - The HTML element containing the scene.
   */
  public initialize(view: RectilinearView, element: HTMLElement): void {
    this.coordinateSystem.initialize(view, element);
  }

  /**
   * Convert screen coordinates to spherical coordinates.
   * Used by scene-hotspot-position directive.
   * @param screenCoords - Screen coordinates to convert.
   * @returns Spherical coordinates or null if conversion fails.
   */
  public screenToSpherical(screenCoords: IScreenCoords): ISphericalCoords | null {
    return this.coordinateSystem.screenToSpherical(screenCoords);
  }

  /**
   * Convert spherical coordinates to screen coordinates.
   * Used by scene-hotspot-position directive.
   * @param sphericalCoords - Spherical coordinates to convert.
   * @returns Screen coordinates or null if conversion fails.
   */
  public sphericalToScreen(sphericalCoords: ISphericalCoords): IScreenCoords | null {
    return this.coordinateSystem.sphericalToScreen(sphericalCoords);
  }

  /**
   * Update cordinate system viewer port bounds.
   *
   * @param element
   */
  public updateViewportBounds(element: HTMLElement): void {
    this.coordinateSystem.updateViewportBounds(element);
  }
}
